import browser from "./browser";
import localStorage from "./localStorage";

function rotateArray(arr, item) {
  var copyArr = arr.slice();
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] != item) {
      copyArr.push(copyArr.shift())
    }
    else {
      break;
    }
  }
  return copyArr;
}

function createStatusText(winnerNames) {
  if (!winnerNames.length) return '';
  else if (winnerNames.length == 1) return winnerNames[0];
  let lastName = winnerNames[winnerNames.length - 1];
  winnerNames.pop();
  return winnerNames.join(', ') + ' and ' + lastName;
}

export default {
  browser,
  localStorage,
  createStatusText,
  rotateArray
};
